import { useEffect, useRef, useState } from "react";

// Hook que detecta cuándo un elemento entra en el viewport usando
// IntersectionObserver nativo (sin dependencias externas). Devuelve un ref
// para asignar al elemento y un booleano `visible` que pasa a true una sola
// vez, cuando el elemento aparece en pantalla.
export const useRevealOnScroll = (opciones = {}) => {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const elemento = ref.current;
    if (!elemento) {
      return undefined;
    }

    // Si el navegador no soporta IntersectionObserver, mostramos el
    // contenido directamente para no ocultarlo nunca.
    if (typeof IntersectionObserver === "undefined") {
      setVisible(true);
      return undefined;
    }

    const observer = new IntersectionObserver(
      (entradas) => {
        entradas.forEach((entrada) => {
          if (entrada.isIntersecting) {
            setVisible(true);
            observer.unobserve(entrada.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: "0px 0px -10% 0px", ...opciones }
    );

    observer.observe(elemento);
    return () => observer.disconnect();
  }, [opciones]);

  return { ref, visible };
};
